import { sleep, postPopup, getCookie } from "./shared";

export function mobilePopup() {
  var popupNieuwsbrief = document.getElementById("popup-nieuwsbrief-head");
  if (popupNieuwsbrief && getCookie("seen_popup") === undefined) {
    sleep(5000).then(() => {
      // Show "footer" popup
      popupNieuwsbrief.classList.toggle("translate-y-full");

      // Add listener to close button
      popupNieuwsbrief.querySelector(".close").addEventListener("click", (e) => {
        e.stopPropagation();
        popupNieuwsbrief.classList.toggle("translate-y-full");
        var date = new Date();
        date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
        document.cookie = "seen_popup=true; expires=T" + date.toUTCString() + ";  path=/;";
      });

      var secondPopup = document.getElementById("popup-nieuwsbrief");

      // Add listener to expand button and bind listeners to second popup
      popupNieuwsbrief.addEventListener("click", () => {
        var date = new Date();
        date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);

        document.cookie = "seen_popup=true; expires=T" + date.toUTCString() + ";  path=/;";
        secondPopup.classList.toggle("translate-y-full");
        popupNieuwsbrief.classList.toggle("translate-y-full");

        secondPopup.querySelector(".close").addEventListener("click", () => {
          secondPopup.classList.toggle("translate-y-full");
        });
      });

      secondPopup.querySelector("button.submit").addEventListener("click", (e) => {
        var date = new Date();
        date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);

        document.cookie = "seen_popup=true; expires=T" + date.toUTCString() + ";  path=/;";
        e.preventDefault();
        postPopup(secondPopup);
      });
    });
  }
}

export function desktopPopup() {
  // If the popup exists i.e. user has see the cookie notice
  var popupNieuwsbrief = document.getElementById("popup-nieuwsbrief");

  var popupNieuwsbriefMobile = document.getElementById("popup-nieuwsbrief-head");
  if (popupNieuwsbrief && getCookie("seen_popup") === undefined && !popupNieuwsbriefMobile) {
    sleep(5000).then(() => {
      // Show popup
      popupNieuwsbrief.classList.toggle("translate-y-full");

      // Add listener to close button
      popupNieuwsbrief.querySelector(".close").addEventListener("click", () => {
        popupNieuwsbrief.classList.toggle("translate-y-full");
        var date = new Date();
        date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);

        document.cookie = "seen_popup=true; expires=T" + date.toUTCString() + ";  path=/;";
      });

      popupNieuwsbrief.querySelector("button.submit").addEventListener("click", (e) => {
        e.preventDefault();
        postPopup(popupNieuwsbrief);
        var date = new Date();
        date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
        document.cookie = "seen_popup=true; expires=T" + date.toUTCString() + ";  path=/;";
      });
    });
  }
}
